// // ============================================================
// // src/components/Footer.js
// // ============================================================
// import React from "react";
// import watermark from "../assets/watermark.png";
// import { useHospital } from "../context/HospitalContext";

// const days = [
//   "Monday",
//   "Tuesday",
//   "Wednesday",
//   "Thursday",
//   "Friday",
//   "Saturday",
//   "Sunday",
// ];
// const hours = [
//   "9am – 8pm",
//   "9am – 8pm",
//   "9am – 8pm",
//   "9am – 8pm",
//   "9am – 8pm",
//   "9am – 6pm",
//   "9am – 5pm",
// ];
// const todayIdx = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;

// export default function Footer() {
//   const { hospital } = useHospital();

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <footer>
//       <div className="footer-top">
//         <div className="footer-col">
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 12,
//               marginBottom: 4,
//             }}
//           >
//             <div
//               style={{
//                 width: 36,
//                 height: 36,
//                 background:
//                   "linear-gradient(135deg,var(--teal),var(--teal-light))",
//                 borderRadius: "50%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: 18,
//                 overflow: "hidden",
//               }}
//             >
//               {hospital.logoUrl ? (
//                 <img
//                   src={hospital.logoUrl}
//                   alt={hospital.name}
//                   style={{ width: 36, height: 36, objectFit: "cover" }}
//                 />
//               ) : (
//                 "🦷"
//               )}
//             </div>
//             <div>
//               <div
//                 style={{
//                   fontFamily: "Cormorant Garamond,serif",
//                   fontSize: 20,
//                   fontWeight: 600,
//                   color: "white",
//                 }}
//               >
//                 {hospital.name.split(" ")[0]}
//               </div>
//               <div
//                 style={{
//                   fontSize: 9,
//                   color: "var(--gold)",
//                   letterSpacing: 2,
//                   textTransform: "uppercase",
//                 }}
//               >
//                 {hospital.tagline}
//               </div>
//             </div>
//           </div>
//           <p className="footer-desc">{hospital.description}</p>
//           <div className="social-links">
//             {["📘", "📸", "🐦", "▶️"].map((icon, i) => (
//               <a key={i} className="social-link" href="#!">
//                 {icon}
//               </a>
//             ))}
//           </div>
//         </div>

//         <div className="footer-col">
//           <h4>Services</h4>
//           <ul>
//             {[
//               "General Dentistry",
//               "Cosmetic Dentistry",
//               "Dental Implants",
//               "Orthodontics",
//               "Root Canal",
//               "Pediatric Dentistry",
//             ].map((s) => (
//               <li key={s}>
//                 <a onClick={() => scrollTo("services")}>{s}</a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div className="footer-col">
//           <h4>Quick Links</h4>
//           <ul>
//             {[
//               ["About Us", "about"],
//               ["Our Doctors", "doctors"],
//               ["Pricing", "pricing"],
//               ["Reviews", "testimonials"],
//               ["FAQ", "faq"],
//               ["Book Appointment", "appointment"],
//             ].map(([label, id]) => (
//               <li key={id}>
//                 <a onClick={() => scrollTo(id)}>{label}</a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         <div className="footer-col">
//           <h4>Clinic Hours</h4>
//           <div className="footer-hours">
//             {days.map((day, i) => (
//               <div
//                 key={day}
//                 className={`hour-row${i === todayIdx ? " today" : ""}`}
//               >
//                 <span>
//                   {day}
//                   {i === todayIdx ? " (Today)" : ""}
//                 </span>
//                 <span>{hours[i]}</span>
//               </div>
//             ))}
//           </div>
//           {/* Contact info */}
//           <div
//             style={{
//               marginTop: 16,
//               fontSize: 13,
//               color: "rgba(255,255,255,0.6)",
//               lineHeight: 1.8,
//             }}
//           >
//             <div>📞 {hospital.phone}</div>
//             <div>✉️ {hospital.email}</div>
//             <div>
//               📍 {hospital.address}, {hospital.city}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── Watermark / Powered by section ─────────────────── */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           padding: "20px 0 12px",
//           borderTop: "1px solid rgba(255,255,255,0.07)",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             background:
//               "linear-gradient(135deg, #0a1628 0%, #0d1f3c 50%, #0a1628 100%)",
//             borderRadius: "14px",
//             padding: "10px 28px",
//             boxShadow:
//               "0 2px 16px rgba(201,168,76,0.08), inset 0 1px 0 rgba(255,255,255,0.05)",
//           }}
//         >
//           <img
//             src={watermark}
//             alt="Vidyastack"
//             style={{ height: "52px", width: "auto", display: "block" }}
//           />
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <p>© 2026 Vidyastack Services pvt ltd. All rights reserved.</p>
//         <div style={{ display: "flex", gap: 24 }}>
//           <a href="#!">Privacy Policy</a>
//           <a href="#!">Terms of Service</a>
//           <a href="#!">Sitemap</a>
//         </div>
//       </div>
//     </footer>
//   );
// }

// ============================================================
// src/components/Footer.js
// ✅ Specialty text wired via getSpecialtyText()
// ============================================================
import React from "react";
import watermark from "../assets/watermark.png";
import { useHospital } from "../context/HospitalContext";
import { getSpecialtyText } from "../utils/specialtyText";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const hours = [
  "9am – 8pm",
  "9am – 8pm",
  "9am – 8pm",
  "9am – 8pm",
  "9am – 8pm",
  "9am – 6pm",
  "9am – 5pm",
];
const todayIdx = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;

export default function Footer() {
  const { hospital } = useHospital();
  const t = getSpecialtyText(hospital.type);
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer>
      <div className="footer-top">
        {/* ── Brand col ── */}
        <div className="footer-col">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 4,
            }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                background:
                  "linear-gradient(135deg,var(--teal),var(--teal-light))",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                overflow: "hidden",
              }}
            >
              {hospital.logoUrl ? (
                <img
                  src={hospital.logoUrl}
                  alt={hospital.name}
                  style={{ width: 36, height: 36, objectFit: "cover" }}
                />
              ) : (
                "🦷"
              )}
            </div>
            <div>
              <div
                style={{
                  fontFamily: "Cormorant Garamond,serif",
                  fontSize: 20,
                  fontWeight: 600,
                  color: "white",
                }}
              >
                {hospital.name.split(" ")[0]}
              </div>
              <div
                style={{
                  fontSize: 9,
                  color: "var(--gold)",
                  letterSpacing: 2,
                  textTransform: "uppercase",
                }}
              >
                {t.footerTagline}
              </div>
            </div>
          </div>
          <p className="footer-desc">{hospital.description}</p>
          <div className="social-links">
            {["📘", "📸", "🐦", "▶️"].map((icon, i) => (
              <a key={i} className="social-link" href="#!">
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* ── Services col ── */}
        <div className="footer-col">
          <h4>{t.footerServices}</h4>
          <ul>
            {[
              t.servicesTag,
              t.navTreatments,
              t.navDoctors,
              "About Us",
              "Reviews",
              t.navBook,
            ].map((s) => (
              <li key={s}>
                <a onClick={() => scrollTo("services")}>{s}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Quick Links col ── */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {[
              ["About Us", "about"],
              [t.navDoctors, "doctors"],
              [t.navTreatments, "pricing"],
              ["Reviews", "testimonials"],
              ["FAQ", "faq"],
              [t.navBook, "appointment"],
            ].map(([label, id]) => (
              <li key={id}>
                <a onClick={() => scrollTo(id)}>{label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Hours col ── */}
        <div className="footer-col">
          <h4>Clinic Hours</h4>
          <div className="footer-hours">
            {days.map((day, i) => (
              <div
                key={day}
                className={`hour-row${i === todayIdx ? " today" : ""}`}
              >
                <span>
                  {day}
                  {i === todayIdx ? " (Today)" : ""}
                </span>
                <span>{hours[i]}</span>
              </div>
            ))}
          </div>
          <div
            style={{
              marginTop: 16,
              fontSize: 13,
              color: "rgba(255,255,255,0.6)",
              lineHeight: 1.8,
            }}
          >
            <div>📞 {hospital.phone}</div>
            <div>✉️ {hospital.email}</div>
            <div>
              📍 {hospital.address}, {hospital.city}
            </div>
          </div>
        </div>
      </div>

      {/* ── Watermark ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px 0 12px",
          borderTop: "1px solid rgba(255,255,255,0.07)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg,#0a1628 0%,#0d1f3c 50%,#0a1628 100%)",
            borderRadius: "14px",
            padding: "10px 28px",
            boxShadow:
              "0 2px 16px rgba(201,168,76,0.08),inset 0 1px 0 rgba(255,255,255,0.05)",
          }}
        >
          <img
            src={watermark}
            alt="Vidyastack"
            style={{ height: "52px", width: "auto", display: "block" }}
          />
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © 2026 PranJeev · Life-Giving Healthcare Platform. All rights
          reserved.
        </p>
        <div style={{ display: "flex", gap: 24 }}>
          <a href="#!">Privacy Policy</a>
          <a href="#!">Terms of Service</a>
          <a href="#!">Sitemap</a>
        </div>
      </div>
    </footer>
  );
}
